import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "site-header__inner" }
const _hoisted_2 = {
  class: "primary-nav",
  "aria-label": "Navegação principal"
}
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = ["aria-label", "aria-expanded"]
const _hoisted_5 = {
  key: 0,
  id: "mobile-navigation",
  class: "mobile-navigation",
  "aria-label": "Navegação principal"
}

import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import ThemeTogglerComponent from "./ThemeTogglerComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const isOpen = ref(false);
const route = useRoute();

const navTabs = [
  { number: "01", name: "Início", path: "/" },
  { number: "02", name: "Sobre", path: "/about" },
  { number: "03", name: "Projetos", path: "/projects" },
  { number: "04", name: "Contato", path: "/contact" },
];

function toggleMenu() {
  isOpen.value = !isOpen.value;
}

function closeMenu() {
  isOpen.value = false;
}

watch(() => route.fullPath, closeMenu);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("header", {
    class: "site-header",
    onKeydown: _withKeys(closeMenu, ["esc"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        class: "site-brand",
        to: "/",
        "aria-label": "spanol.dev — início",
        onClick: closeMenu
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", {
            class: "site-brand__mark",
            "aria-hidden": "true"
          }, [
            _createElementVNode("svg", {
              viewBox: "0 0 64 64",
              focusable: "false"
            }, [
              _createElementVNode("g", { transform: "translate(0 -3)" }, [
                _createElementVNode("path", {
                  class: "site-brand__glyph",
                  d: "M56 6H24C12 6 5 13 5 24s7 18 20 18h9c6 0 9 2 9 7s-3 6-10 6H6v9h28c13 0 21-7 21-19s-8-19-21-19h-9c-5 0-8-2-8-6s3-7 8-7h31z"
                }),
                _createElementVNode("path", {
                  class: "site-brand__fold",
                  d: "M44 7h11v11z"
                })
              ])
            ])
          ], -1),
          _createElementVNode("span", {
            class: "site-brand__name",
            "aria-hidden": "true"
          }, [
            _createElementVNode("strong", null, [
              _createTextVNode("spanol"),
              _createElementVNode("span", null, "."),
              _createTextVNode("dev")
            ])
          ], -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navTabs, (tab) => {
          return _createVNode(_component_RouterLink, {
            key: tab.path,
            to: tab.path,
            class: "primary-nav__link",
            "active-class": "primary-nav__link--active",
            "aria-label": `${tab.number} ${tab.name}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(tab.number), 1),
              _createElementVNode("b", null, _toDisplayString(tab.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "aria-label"])
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("a", {
          class: "resume-link",
          href: "/curriculum.docx",
          download: ""
        }, [
          _createElementVNode("span", null, "CURRÍCULO"),
          _createElementVNode("span", { "aria-hidden": "true" }, "↗")
        ], -1)),
        _createVNode(ThemeTogglerComponent),
        _createElementVNode("button", {
          class: "menu-toggle",
          type: "button",
          "aria-label": isOpen.value ? 'Fechar navegação' : 'Abrir navegação',
          "aria-expanded": isOpen.value,
          "aria-controls": "mobile-navigation",
          onClick: toggleMenu
        }, [
          _createVNode(_component_v_icon, {
            name: isOpen.value ? 'io-close' : 'bi-list',
            scale: "1.25",
            "aria-hidden": "true"
          }, null, 8, ["name"])
        ], 8, _hoisted_4)
      ])
    ]),
    _createVNode(_Transition, { name: "menu-drop" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navTabs, (tab) => {
                return _createVNode(_component_RouterLink, {
                  key: tab.path,
                  to: tab.path,
                  class: "mobile-navigation__link",
                  "active-class": "mobile-navigation__link--active",
                  onClick: closeMenu
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(tab.number), 1),
                    _createTextVNode(_toDisplayString(tab.name), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("b", { "aria-hidden": "true" }, "↗", -1))
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64)),
              _cache[3] || (_cache[3] = _createElementVNode("a", {
                class: "mobile-navigation__resume",
                href: "/curriculum.docx",
                download: ""
              }, [
                _createTextVNode(" Baixar currículo "),
                _createElementVNode("span", { "aria-hidden": "true" }, "↗")
              ], -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}
}

})